"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RadioQuestionWidget = void 0;
var React = require("react");
var SelectQuestionWidgetBase_1 = require("./SelectQuestionWidgetBase");
var CustomRadioInput_1 = require("../components/CustomRadioInput");
var journey_model_1 = require("@athena-portal/journey-model");
var journey_services_1 = require("@athena-portal/journey-services");
var RadioQuestionWidget = exports.RadioQuestionWidget = /** @class */ (function (_super) {
    __extends(RadioQuestionWidget, _super);
    function RadioQuestionWidget() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.validate = function (value) {
            _super.prototype.validateInternal.call(_this, value);
        };
        return _this;
    }
    RadioQuestionWidget_1 = RadioQuestionWidget;
    RadioQuestionWidget.prototype.renderInputField = function () {
        var _this = this;
        var renderedInputs = null;
        if (this.state.lookupValues) {
            renderedInputs = this.state.lookupValues.map(function (v) { return (React.createElement(CustomRadioInput_1.CustomRadioInput, { name: _this.props.question.name, key: v.id, inputClassName: _this.getInputValidationClass(), id: v.id, value: journey_services_1.ExpressionEvaluator.renderTemplate(v.value, _this.props.interaction), isChecked: _this.isChecked(v.id), onChange: _this.handleOnChangeEvent, validate: _this.validate, readOnly: _this.isReadOnly(), disabled: _this.getSetting(RadioQuestionWidget_1.inputDisabledSetting, false) })); });
        }
        return (React.createElement(React.Fragment, null, renderedInputs));
    };
    RadioQuestionWidget.prototype.handleOnChangeEvent = function (event) {
        _super.prototype.handleOnChangeEvent.call(this, event);
    };
    RadioQuestionWidget.prototype.isChecked = function (id) {
        return (id === "".concat(this.bindFromField(this.props.question.interactionField)));
    };
    var RadioQuestionWidget_1;
    RadioQuestionWidget.inputDisabledSetting = "inputDisabled";
    RadioQuestionWidget = RadioQuestionWidget_1 = __decorate([
        (0, journey_model_1.event)(journey_model_1.Event.onChange),
        (0, journey_model_1.settings)([
            { name: "inputDisabled", type: journey_model_1.TypeDescriptions.Boolean },
        ])
    ], RadioQuestionWidget);
    return RadioQuestionWidget;
}(SelectQuestionWidgetBase_1.SelectQuestionWidgetBase));
//# sourceMappingURL=RadioQuestionWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/@athena-portal/plugin-journey/dist/widgets/input/RadioQuestionWidget.js
// module id = 2358
// module chunks = 0